<div class="layout-topbar">
    <div class="flex flex-1 align-items-center justify-content-between">
        <div class="flex justify-content-center align-items-center my-4">
            <a class="layout-topbar-logo cursor-pointer" (click)="navigateHome()">
                <span><img src="assets/images/smarthink-main-logo.svg" alt="logo" /></span>
            </a>

            <button
                #menubutton
                class="p-link layout-menu-button layout-topbar-button"
                (click)="layoutService.onMenuToggle()"
            >
                <i class="pi pi-bars"></i>
            </button>
        </div>

        <div *ngIf="user" class="avatar flex align-items-center">
            <div class="language-switch flex align-items-center justify-content-center">
                <p-button
                    icon="material-icons mi-keyboard-arrow-down"
                    iconPos="right"
                    (click)="currentLang === 'en' ? changeLanguage('el') : changeLanguage('en')"
                    label="{{currentLang.toUpperCase()}}"
                    styleClass="w-6rem"
                    [rounded]="true"
                    [outlined]="true"
                />
            </div>
        </div>
    </div>
</div>
